import React  from 'react';
import DateComponentProto from './date-proto';


export default function renderDateInEdit(id, props) {
    return <DateComponentProto renderMode="edit" id={id} {...props} />;
}